export const formatDollarValue = (x, lang, withDollarSign, useAbbreviations) => {
    if (x === undefined || x === null || Number.isNaN(x))
        return '';
    const locale = (lang !== null && lang !== void 0 ? lang : 'en').toLowerCase();
    const isFrench = locale.startsWith('fr');
    const nf = new Intl.NumberFormat(isFrench ? 'fr-CA' : 'en-CA', {
        minimumFractionDigits: 0,
        maximumFractionDigits: useAbbreviations ? 1 : 2,
    });
    const abs = Math.abs(x);
    let value = abs;
    let scale = 'none';
    if (useAbbreviations) {
        if (abs >= 1e12) {
            value = abs / 1e12;
            scale = 'trillion';
        }
        else if (abs >= 1e9) {
            value = abs / 1e9;
            scale = 'billion';
        }
        else if (abs >= 1e6) {
            value = abs / 1e6;
            scale = 'million';
        }
        else if (abs >= 1e3) {
            value = abs / 1e3;
            scale = 'thousand';
        }
    }
    let numStr = nf.format(value);
    if (x < 0)
        numStr = `-${numStr}`;
    const nbsp = '\u00A0';
    const enUnit = (s) => {
        switch (s) {
            case 'thousand':
                return 'k';
            case 'million':
                return 'M';
            case 'billion':
                return 'B';
            case 'trillion':
                return 'T';
            default:
                return '';
        }
    };
    const frUnit = (s, withDollar) => {
        switch (s) {
            case 'thousand':
                return withDollar ? 'k$' : 'k';
            case 'million':
                return withDollar ? 'M$' : 'M';
            case 'billion':
                return withDollar ? 'G$' : 'G';
            case 'trillion':
                return withDollar ? 'T$' : 'T';
            default:
                return withDollar ? '$' : '';
        }
    };
    if (!withDollarSign) {
        if (isFrench) {
            if (scale !== 'none')
                return `${numStr}${nbsp}${frUnit(scale, false)}`;
            return numStr;
        }
        else {
            const unit = enUnit(scale);
            return `${numStr}${unit}`;
        }
    }
    if (isFrench) {
        if (scale !== 'none') {
            return `${numStr}${nbsp}${frUnit(scale, true)}`;
        }
        return `${numStr}${nbsp}$`;
    }
    const unit = enUnit(scale);
    return `$${numStr}${unit}`;
};
